import { ResponseStatus } from '../../../Response'
import { Action, getModule, Module, Mutation, VuexModule } from 'vuex-module-decorators'
import store from '@/store'
import { Role, RoleType, Secure } from '@api/Secure'
import PreExamLSGateway, {
  DailyExaminationResponse,
  EffectiveLSAndCommoditySkuResponse,
  PreExamLSResponse,
  StudentIdentityResponse,
  UserPreExamLSIssueResponse,
  UserPreExamLSResponse
} from '@api/gateway/PreExamLS-default'
import PlatformUserLearningScheme from '@api/gateway/PlatformUserLearningScheme'
import Effectiveness, { IssueEffectivenessCode } from '@api/model/myscheme/Effectiveness'
import { Constants } from '@api/model/common/Constants'
import moment from 'moment'
import PlatformLearningScheme, { IssueLinkResponse } from '@api/gateway/PlatformLearningScheme'

/**
 * 本地状态数据
 */
interface MySchemeState {
  /**
   * 我报名的所有培训方案
   */
  myLearningSchemeList: Array<UserPreExamLSResponse>
  /**
   * 我的培训班下期数列表
   */
  mySchemeIssueList: Array<UserPreExamLSIssueResponse>

  /**
   * 期别学习方案详情
   */
  issueLearningSchemeDetailDTO: PreExamLSResponse

  /**
   * 有效期学习方案详情
   */
  effectiveLearningSchemeDetailDTO: EffectiveLSAndCommoditySkuResponse
  /**
   * 期数是否有效信息
   */
  issueEffectiveInfo: Effectiveness
  /**
   * 当前方案有效的期别信息
   */
  mySchemeEffectiveIssue: UserPreExamLSIssueResponse
  /**
   * 当前培训班下默认的账号有效期
   */
  // mySchemeStudentityIdentity: StudentIdentityResponse
  /**
   * 期数下的learningId
   */
  issueLearningIdMap: Map<string, Array<IssueLinkResponse>>
  /**
   * 期数的每日一卷信息
   */
  dailyExaminationResponse: DailyExaminationResponse
}

/**
 * 我的学习方案模块
 */
@Module({ namespaced: true, dynamic: true, name: 'LearningSchemeModule', store })
class LearningSchemeModule extends VuexModule implements MySchemeState {
  //region implements
  /**
   * 我报名的所有培训方案
   */
  myLearningSchemeList: Array<UserPreExamLSResponse> = new Array<UserPreExamLSResponse>()

  /**
   * 期别学习方案详情
   */
  issueLearningSchemeDetailDTO: PreExamLSResponse = new PreExamLSResponse()

  /**
   * 有效期学习方案详情
   */
  effectiveLearningSchemeDetailDTO: EffectiveLSAndCommoditySkuResponse = new EffectiveLSAndCommoditySkuResponse()

  /**
   * 我的培训班下期数列表
   */
  mySchemeIssueList: Array<UserPreExamLSIssueResponse> = new Array<UserPreExamLSIssueResponse>()

  /**
   * 我的培训班下有效期列表
   */
  mySchemeStudentityIdentityList: Array<StudentIdentityResponse> = new Array<StudentIdentityResponse>()
  /**
   * 期数是否有效信息
   */
  issueEffectiveInfo = new Effectiveness()
  /**
   * 当前方案有效的期别信息
   */
  mySchemeEffectiveIssue: UserPreExamLSIssueResponse = new UserPreExamLSIssueResponse()
  /**
   * 当前培训班下默认的账号有效期
   */
  mySchemeStudentityIdentity: StudentIdentityResponse = new StudentIdentityResponse()

  /**
   * 期数下的learningId
   */
  issueLearningIdMap: Map<string, Array<IssueLinkResponse>> = new Map<string, Array<IssueLinkResponse>>()
  /**
   * 期数的每日一卷信息
   */
  dailyExaminationResponse = new DailyExaminationResponse()
  // defaultIssueEffectiveMap: Map<string, { issueId: string; userId: string }> = new Map<
  //   string,
  //   { issueId: ''; userId: '' }
  // >()
  //endregion

  //region actions
  /**
   * 读取默认期别/账号有效期Id
   */
  // @Action
  // async getDefaultIssueEffective(schemeId: string) {
  //   const responseStatus = await UserModule.queryUserInfo()
  //   if (!responseStatus.isSuccess()) {
  //     return { issueId: '', userId: '' }
  //   }
  //   if (UserModule.userInfo && UserModule.userInfo.userId) {
  //     // const value = localStorage.getItem(schemeId + '_' + UserModule.userInfo.userId)
  //     // if (value) {
  //     //   const values = value.split('_')
  //     //   return { issueId: values[0], userId: values[1] }
  //     // }
  //     if (document) {
  //       const reg = new RegExp('(^| )' + schemeId + '_' + UserModule.userInfo.userId + '=([^;]*)(;|$)')
  //       const value = document.cookie.match(reg)
  //       if (value) {
  //         const values = unescape(value[2]).split('_')
  //         return { issueId: values[0], userId: values[1] }
  //       }
  //     } else {
  //       const response = this.defaultIssueEffectiveMap.get(schemeId + '_' + UserModule.userInfo.userId)
  //       if (response) {
  //         return response
  //       }
  //     }
  //   }
  //   return { issueId: '', userId: '' }
  // }

  /**
   * 缓存默认期别/账号有效期Id
   */
  // @Action
  // async setDefaultIssueEffective(params: { schemeId: string; issueId: string; userId: string }) {
  //   const responseStatus = await UserModule.queryUserInfo()
  //   if (!responseStatus.isSuccess()) {
  //     return
  //   }
  //   // localStorage.setItem(params.schemeId + '_' + UserModule.userInfo.userId, params.issueId + '_' + params.userId)
  //   if (document) {
  //     document.cookie =
  //       params.schemeId + '_' + UserModule.userInfo.userId + '=' + escape(params.issueId + '_' + params.userId)
  //   }
  //   this.defaultIssueEffectiveMap.set(params.schemeId + '_' + UserModule.userInfo.userId, {
  //     issueId: params.issueId,
  //     userId: params.userId
  //   })
  // }

  /**
   * 获取我的报名班级列表
   */
  @Role([RoleType.user])
  @Secure({
    PlatformUserLearningScheme: ['query.listUserIssueReservation', 'query.validUserIssue']
  })
  @Action
  async findMySchemeList() {
    if (this.myLearningSchemeList && this.myLearningSchemeList.length > 0) {
      return new ResponseStatus(200, '')
    }
    const response = await PreExamLSGateway.findAllByUser()
    if (!response.status.isSuccess()) {
      return response.status
    }
    const userSchemeList: Array<UserPreExamLSResponse> = new Array<UserPreExamLSResponse>()
    for (const scheme of response.data) {
      const userScheme = new UserPreExamLSResponse()
      Object.assign(userScheme, scheme)
      userScheme.picture = scheme.picture ? '/mfs/' + scheme.picture : ''
      userSchemeList.push(userScheme)
    }
    this.SET_MY_LEARNING_SCHEME_LIST({ learningSchemeList: userSchemeList })
    return response.status
  }

  /**
   * 获取期数学习方案
   * @param schemeId
   */
  @Action
  @Secure({
    PlatformLearningScheme: ['query.findIssueLSById']
  })
  async findIssueLSById(schemeId: string) {
    if (this.issueLearningSchemeDetailDTO && this.issueLearningSchemeDetailDTO.schemeId === schemeId) {
      return new ResponseStatus(200, '')
    }
    const response = await PreExamLSGateway.findIssueLSById(schemeId)
    this.SET_ISSUE_LEARNING_SCHEME_DETAIL(response.data)
    return response.status
  }

  /**
   * 获取有效期学习方案
   * @param schemeId
   */
  @Action
  @Secure({
    PlatformLearningScheme: ['query.findEffectiveLSById']
  })
  async findEffectiveLSById(schemeId: string) {
    if (this.effectiveLearningSchemeDetailDTO && this.effectiveLearningSchemeDetailDTO.schemeId === schemeId) {
      return new ResponseStatus(200, '')
    }
    const response = await PreExamLSGateway.findEffectiveLSById(schemeId)
    this.SET_EFFECTIVE_LEARNING_SCHEME_DETAIL(response.data)
    return response.status
  }

  /**
   * 获取方案下期别类型期数列表
   */
  @Action
  @Role([RoleType.user])
  @Secure({
    PlatformUserLearningScheme: ['query.findIssueListByCurrentUser']
  })
  async findIssueListByCurrentUser(schemeId: string) {
    if (
      this.mySchemeIssueList &&
      this.mySchemeIssueList.length > 0 &&
      this.mySchemeIssueList.every(i => i.schemeId === schemeId)
    ) {
      return new ResponseStatus(200, '')
    }
    const response = await PreExamLSGateway.findIssueListByCurrentUser(schemeId)

    if (response.status.isSuccess()) {
      this.SET_LEARNING_SCHEME_ISSUE_LIST(response.data)
      // return this.findEffectiveIssueByCurrentUser(schemeId)
    }
    return response.status
  }

  /**
   * 获取方案下账号有效期类型期数列表
   */
  @Action
  @Role([RoleType.user])
  @Secure({
    PlatformUserLearningScheme: ['query.findStudentIdentityListByCurrentUser']
  })
  async findStudentIdentityListByCurrentUser(schemeId: string) {
    if (
      this.mySchemeStudentityIdentityList &&
      this.mySchemeStudentityIdentityList.length > 0 &&
      this.mySchemeStudentityIdentityList.every(i => i.schemeId === schemeId)
    ) {
      return new ResponseStatus(200, '')
    }
    const response = await PreExamLSGateway.findStudentIdentityListByCurrentUser(schemeId)
    if (response.status.isSuccess()) {
      this.SET_LEARNING_SCHEME_EFFECTIVE_LIST(response.data)
      const status = await this.findIssueLearningId(response.data[0].issueId)
      if (!status.isSuccess()) {
        return status
      }
      if (response.data.length > 0) {
        this.SET_EFFECTIVE_ISSUE_LEARNING_ID(response.data[0].issueId)
      }
      // return this.findEffectiveStudentIdentityByCurrentUser(schemeId)
    }
    return response.status
  }

  /**
   * 获取当前有效的期别信息
   */
  @Action
  @Role([RoleType.user])
  @Secure({
    PlatformUserLearningScheme: ['query.findIssueListByCurrentUser']
  })
  async findEffectiveIssueByCurrentUser(schemeId: string) {
    if (this.mySchemeEffectiveIssue && this.mySchemeEffectiveIssue.schemeId === schemeId) {
      return new ResponseStatus(200, '')
    }
    if (!this.mySchemeIssueList) {
      const response = await PreExamLSGateway.findIssueListByCurrentUser(schemeId)
      if (!response.status.isSuccess()) {
        return response.status
      }
      this.SET_LEARNING_SCHEME_ISSUE_LIST(response.data)
    }

    let isExist = false
    const mySchemeIssue = this.mySchemeIssueList.find(m => m.effective)
    if (mySchemeIssue) {
      isExist = true
      this.SET_MY_SCHEME_EFFECTIVE_ISSUE(mySchemeIssue)
      const status = await this.findIssueLearningId(mySchemeIssue.issueId)
      if (!status.isSuccess()) {
        return status
      }
      this.SET_ISSUE_LEARNING_ID(mySchemeIssue.issueId)
      // this.setDefaultIssueEffective({
      //   schemeId: mySchemeIssue.schemeId,
      //   issueId: mySchemeIssue.issueId,
      //   userId: mySchemeIssue.userId
      // })
      return status
    }
    // 如果不存在 设置第一个
    if (!isExist) {
      this.SET_MY_SCHEME_EFFECTIVE_ISSUE(this.mySchemeIssueList[0])
      const status = await this.findIssueLearningId(this.mySchemeIssueList[0].issueId)
      if (!status.isSuccess()) {
        return status
      }
      this.SET_ISSUE_LEARNING_ID(this.mySchemeIssueList[0].issueId)
    }
    return new ResponseStatus(200, '')
  }

  /**
   * 获取学习期别的有效情况
   * @param params 期别编号
   */
  @Action
  @Role([RoleType.user])
  @Secure({
    PlatformUserLearningScheme: ['query.validUserIssue']
  })
  async validUserIssue(params: { issueId: string; userId: string }) {
    if (this.issueEffectiveInfo && this.issueEffectiveInfo.issueId === params.issueId) {
      return new ResponseStatus(200, '')
    }
    const response = await PlatformUserLearningScheme.validUserIssue({
      issueId: params.issueId,
      userId: params.userId
    })
    if (!response.status.isSuccess()) {
      return response.status
    }
    this.SET_ISSUE_EFFECTIVE_INFO({ issueId: params.issueId, code: response.data.code, message: response.data.message })
    return response.status
  }

  /**
   * 获取当前默认的账号有效期信息
   */
  // @Action
  // @Role([RoleType.user])
  // @Secure({
  //   PlatformUserLearningScheme: ['query.findIssueListByCurrentUser']
  // })
  // async findEffectiveStudentIdentityByCurrentUser(schemeId: string) {
  //   if (!this.mySchemeStudentityIdentityList) {
  //     const response = await PreExamLSGateway.findStudentIdentityListByCurrentUser(schemeId)
  //
  //     if (!response.status.isSuccess()) {
  //       return response.status
  //     }
  //     this.SET_LEARNING_SCHEME_EFFECTIVE_LIST(response.data)
  //   }
  //   const { issueId, userId } = await this.getDefaultIssueEffective(schemeId)
  //   for (const mySchemeStudentityIdentity of this.mySchemeStudentityIdentityList) {
  //     if (
  //       issueId &&
  //       userId &&
  //       issueId === mySchemeStudentityIdentity.issueId &&
  //       userId === mySchemeStudentityIdentity.userId
  //     ) {
  //       this.SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(mySchemeStudentityIdentity)
  //       return new ResponseStatus(200, '')
  //     }
  //   }
  //   this.setDefaultIssueEffective({
  //     schemeId: this.mySchemeStudentityIdentityList[0].schemeId,
  //     issueId: this.mySchemeStudentityIdentityList[0].issueId,
  //     userId: this.mySchemeStudentityIdentityList[0].id
  //   })
  //   this.SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(this.mySchemeStudentityIdentityList[0])
  //   return new ResponseStatus(200, '')
  // }

  /**
   * 获取当前期数下所有learningId
   */
  @Action
  @Role([RoleType.user])
  @Secure({
    PlatformLearningScheme: ['query.listIssueLink']
  })
  async findIssueLearningId(issueId: string) {
    const issueLearningIdList = this.issueLearningIdMap.get(issueId)
    if (issueLearningIdList && issueLearningIdList.length > 0) {
      return new ResponseStatus(200, '')
    }
    const response = await PlatformLearningScheme.listIssueLink(issueId)
    if (!response.status.isSuccess()) {
      return response.status
    }
    this.SET_ISSUE_LEARNING_ID_LIST({ issueId: issueId, issueLearningIdList: response.data })
    return response.status
  }

  /**
   * 重新加载我的报名班级
   */
  @Action
  doRefreshLearningScheme(): Promise<ResponseStatus> {
    return this.findMySchemeList()
  }

  /**
   * 重新加载用户期别数据
   */
  @Action
  setEnableLoadLearningScheme(): void {
    // Todo
    console.log(1)
  }

  @Action
  restData() {
    this.SET_MY_LEARNING_SCHEME_LIST({
      learningSchemeList: new Array<UserPreExamLSResponse>()
    })
  }

  /**
   * 获取期数的每日一卷信息
   * （暂无使用）
   * @param param
   */
  @Action
  async getIssueDailyExamination(param: { schemeId: string; issueId: string }) {
    const res = await PreExamLSGateway.getIssueDailyExamination({
      schemeId: param.schemeId,
      issueId: param.issueId
    })
    if (res.status.isSuccess()) {
      this.SET_ISSUE_DAILY_EXAM(res.data)
    }
  }

  //endregion

  //region getters
  /**
   * 指示获取我的所有学习方案
   */
  get getAllLearningScheme(): Array<UserPreExamLSResponse> {
    return this.myLearningSchemeList
  }

  /**
   * 获取指定行业、专业下的学习方案
   */
  get getLearningSchemeByIndustryIdAndMajorId() {
    return (examTypeId: string, professionId: string): Array<UserPreExamLSResponse> | undefined => {
      if (this.myLearningSchemeList?.length) {
        return this.myLearningSchemeList.filter(x => x.examTypeId === examTypeId && x.professionId === professionId)
      }
      return undefined
    }
  }

  /**
   * 根据用户已报名的某个方案id获取对应配置的考纲树id
   */
  get getUserSyllabusIdBySchemeId() {
    return (schemeId: string): string => {
      if (schemeId) {
        return this.myLearningSchemeList.find(x => x.schemeId === schemeId)?.syllabusId || ''
      }
      return ''
    }
  }

  /**
   * 根据用户已报名的某个方案id获取对应配置的专业id
   */
  get getUserMajorIdBySchemeId() {
    return (schemeId: string): string => {
      if (schemeId) {
        return this.myLearningSchemeList.find(x => x.schemeId === schemeId)?.professionId || ''
      }
      return ''
    }
  }

  /**
   * 根据用户已报名的某个方案id获取对应的年度sku值
   */
  get getYearBySchemeSku() {
    return (schemeId: string): number => {
      if (schemeId) {
        return this.myLearningSchemeList.find(x => x.schemeId === schemeId)?.year || 2020
      }
      return 2020
    }
  }

  /**
   * 获取方案下学员账号有效期信息
   */
  get getSchemeStudentityIdentityList() {
    return this.mySchemeStudentityIdentityList
  }

  /**
   * 获取某个方案信息
   * @param state 状态
   */
  get getLearningSchemeBySchemeId() {
    return (schemeId: string) => {
      return this.getAllLearningScheme.find(x => x.schemeId === schemeId)
    }
  }

  //endregion
  /**
   * 获取方案下已报名未开始的期数列表
   */
  get getSchemeIssueUnStartedList() {
    return this.mySchemeIssueList.filter(
      issue => moment(issue.startTime, Constants.DATE_PATTERN).valueOf() > new Date().getTime()
    )
  }

  //region mutations
  @Mutation
  SET_ISSUE_LEARNING_ID(issueId: string) {
    const issueLearningList = this.issueLearningIdMap.get(issueId)
    if (!issueLearningList || issueLearningList.length <= 0) {
      return new ResponseStatus(500, '')
    }
    for (const issueLearning of issueLearningList) {
      if (issueLearning.learningResourceType === 2) {
        if (this.issueLearningSchemeDetailDTO.courseLearning) {
          this.issueLearningSchemeDetailDTO.courseLearning.learningId = issueLearning.learningId
        }
      }
      if (issueLearning.learningResourceType === 3) {
        if (this.issueLearningSchemeDetailDTO.examLearning) {
          this.issueLearningSchemeDetailDTO.examLearning.learningId = issueLearning.learningId
        }
      }
      if (issueLearning.learningResourceType === 10) {
        if (this.issueLearningSchemeDetailDTO.questionPracticeLearning) {
          this.issueLearningSchemeDetailDTO.questionPracticeLearning.learningId = issueLearning.learningId
        }
        if (this.issueLearningSchemeDetailDTO.dailyPractice) {
          this.issueLearningSchemeDetailDTO.dailyPractice.learningId = issueLearning.learningId
        }
        if (this.issueLearningSchemeDetailDTO.errorPronePractice) {
          this.issueLearningSchemeDetailDTO.errorPronePractice.learningId = issueLearning.learningId
        }
      }
    }
  }

  @Mutation
  SET_EFFECTIVE_ISSUE_LEARNING_ID(issueId: string) {
    const issueLearningList = this.issueLearningIdMap.get(issueId)
    if (!issueLearningList || issueLearningList.length <= 0) {
      return new ResponseStatus(500, '')
    }
    for (const issueLearning of issueLearningList) {
      if (issueLearning.learningResourceType === 2) {
        if (this.effectiveLearningSchemeDetailDTO.courseLearning) {
          this.effectiveLearningSchemeDetailDTO.courseLearning.learningId = issueLearning.learningId
        }
      }
      if (issueLearning.learningResourceType === 3) {
        if (this.effectiveLearningSchemeDetailDTO.examLearning) {
          this.effectiveLearningSchemeDetailDTO.examLearning.learningId = issueLearning.learningId
        }
      }
      if (issueLearning.learningResourceType === 10) {
        if (this.effectiveLearningSchemeDetailDTO.questionPracticeLearning) {
          this.effectiveLearningSchemeDetailDTO.questionPracticeLearning.learningId = issueLearning.learningId
        }
        if (this.effectiveLearningSchemeDetailDTO.dailyPractice) {
          this.effectiveLearningSchemeDetailDTO.dailyPractice.learningId = issueLearning.learningId
        }
        if (this.effectiveLearningSchemeDetailDTO.errorPronePractice) {
          this.effectiveLearningSchemeDetailDTO.errorPronePractice.learningId = issueLearning.learningId
        }
      }
    }
  }

  @Mutation
  SET_ISSUE_LEARNING_ID_LIST(params: { issueId: string; issueLearningIdList: Array<IssueLinkResponse> }) {
    this.issueLearningIdMap.set(params.issueId, params.issueLearningIdList)
  }

  /**
   * 期数是否有效信息
   */
  @Mutation
  SET_ISSUE_EFFECTIVE_INFO(params: { issueId: string; code: string; message: string }) {
    this.issueEffectiveInfo = new Effectiveness()
    this.issueEffectiveInfo.issueId = params.issueId
    this.issueEffectiveInfo.isEffective = params.code === IssueEffectivenessCode.EFFECTIVE
    this.issueEffectiveInfo.code = params.code as IssueEffectivenessCode
    this.issueEffectiveInfo.message = params.message
  }

  /**
   * 当前方案默认的账号有效期信息
   */
  @Mutation
  private SET_MY_SCHEME_EFFECTIVE_STUDENT_IDENTITY(mySchemeStudentityIdentity: StudentIdentityResponse) {
    this.mySchemeStudentityIdentity = mySchemeStudentityIdentity
  }

  /**
   * 当前方案有效的期别信息
   */
  @Mutation
  private SET_MY_SCHEME_EFFECTIVE_ISSUE(mySchemeEffectiveIssue: UserPreExamLSIssueResponse) {
    this.mySchemeEffectiveIssue = mySchemeEffectiveIssue
  }

  /**
   * 设置我报名培训班列表
   * @param params 参数：learningSchemeList - 我的期数列表
   */
  @Mutation
  private SET_MY_LEARNING_SCHEME_LIST(params: { learningSchemeList: Array<UserPreExamLSResponse> }) {
    this.myLearningSchemeList = params.learningSchemeList
  }

  /**
   * 设置期数方案详情
   * @param issueLearningSchemeDetailDTO
   * @constructor
   */
  @Mutation
  private SET_ISSUE_LEARNING_SCHEME_DETAIL(issueLearningSchemeDetailDTO: PreExamLSResponse) {
    //后端给的方案的learningId，不返回给前端，返回期数的learningId给前端
    if (issueLearningSchemeDetailDTO.courseLearning?.learningId) {
      issueLearningSchemeDetailDTO.courseLearning.learningId = ''
    }
    if (issueLearningSchemeDetailDTO.examLearning?.learningId) {
      issueLearningSchemeDetailDTO.examLearning.learningId = ''
    }
    if (issueLearningSchemeDetailDTO.questionPracticeLearning?.learningId) {
      issueLearningSchemeDetailDTO.questionPracticeLearning.learningId = ''
    }
    if (issueLearningSchemeDetailDTO.dailyPractice?.learningId) {
      issueLearningSchemeDetailDTO.dailyPractice.learningId = ''
    }
    if (issueLearningSchemeDetailDTO.errorPronePractice?.learningId) {
      issueLearningSchemeDetailDTO.errorPronePractice.learningId = ''
    }
    this.issueLearningSchemeDetailDTO = issueLearningSchemeDetailDTO
  }

  /**
   * 设置有效期方案详情
   * @param effectiveLearningSchemeDetailDTO
   * @constructor
   */
  @Mutation
  private SET_EFFECTIVE_LEARNING_SCHEME_DETAIL(effectiveLearningSchemeDetailDTO: EffectiveLSAndCommoditySkuResponse) {
    //后端给的方案的learningId，不返回给前端，返回期数的learningId给前端
    if (effectiveLearningSchemeDetailDTO.courseLearning?.learningId) {
      effectiveLearningSchemeDetailDTO.courseLearning.learningId = ''
    }
    if (effectiveLearningSchemeDetailDTO.examLearning?.learningId) {
      effectiveLearningSchemeDetailDTO.examLearning.learningId = ''
    }
    if (effectiveLearningSchemeDetailDTO.questionPracticeLearning?.learningId) {
      effectiveLearningSchemeDetailDTO.questionPracticeLearning.learningId = ''
    }
    if (effectiveLearningSchemeDetailDTO.dailyPractice?.learningId) {
      effectiveLearningSchemeDetailDTO.dailyPractice.learningId = ''
    }
    if (effectiveLearningSchemeDetailDTO.errorPronePractice?.learningId) {
      effectiveLearningSchemeDetailDTO.errorPronePractice.learningId = ''
    }
    this.effectiveLearningSchemeDetailDTO = effectiveLearningSchemeDetailDTO
  }

  /**
   * 设置方案下期别列表
   * @param mySchemeIssueList
   * @constructor
   */
  @Mutation
  private SET_LEARNING_SCHEME_ISSUE_LIST(mySchemeIssueList: Array<UserPreExamLSIssueResponse>) {
    this.mySchemeIssueList = mySchemeIssueList
  }

  /**
   * 设置方案下账号有效期列表
   * @param mySchemeStudentityIdentityList
   * @constructor
   */
  @Mutation
  private SET_LEARNING_SCHEME_EFFECTIVE_LIST(mySchemeStudentityIdentityList: Array<StudentIdentityResponse>) {
    this.mySchemeStudentityIdentityList = mySchemeStudentityIdentityList
  }

  /**
   * 设置期数的每日一卷信息
   * @param dailyExaminationResponse
   * @constructor
   */
  @Mutation
  private SET_ISSUE_DAILY_EXAM(dailyExaminationResponse: DailyExaminationResponse) {
    this.dailyExaminationResponse = dailyExaminationResponse
  }
  //endregion
}

export default getModule(LearningSchemeModule)
